import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IManagerBonusClientMonthly } from '@entities/managersPerformance/IManagerBonus';

export const fetch = async ({
  managerId,
  month,
  year,
}: {
  month: number;
  managerId: number;
  year: number;
}): Promise<IManagerBonusClientMonthly[]> => {
  const response = await api.get<IManagerBonusClientMonthly[]>(
    `${BI_BASE_URL}/managers/manager/${managerId}/bonus/${month}/clients`,
    { params: { year } }
  );

  return response.data ?? [];
};

export const useManagerBonusClients = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
